import React from 'react';
import PageTitle from '../FormElements/PageTitle';
import GlobalErrorsBox from '../ErrorComponents/GlobalErrorBox/GlobalErrorsBox';
import FormSection from '../FormElements/FormSection';
import FormSubmit from '../FormElements/FormSubmit';
import Label from '../FormElements/Label';
import TextInput from '../FormElements/TextInput';
import EmailInput from '../FormElements/EmailInput';
import PasswordInput from '../FormElements/PasswordInput';
import PrimaryButton from '../Buttons/PrimaryButton';
import SecondaryButton from '../Buttons/SecondaryButton';

export default class InquiryForm extends React.Component {
	constructor() {
		super();

		this.state = {
			name: '',
			emailAddress: '',
			howCanWeHelpYou: '',
			howDidYouHearAboutUs: ''
		};

		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}
	componentDidMount() {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});
	}

	render() {
		// console.log('InquiryForm', this.props, this.state);
		return (
			<div className="w-full py-4">
				<PageTitle title={this.props.hideTitle ? '' : 'Create inquiry'} />
				<GlobalErrorsBox globalErrors={this.state.errors} />
				<FormSection>
					<Label htmlFor="name">Name *</Label>
					<TextInput
						id="name"
						name="name"
						value={this.state.name}
						onChange={this.onChange}
					/>
					<Label htmlFor="emailAddress">Email *</Label>
					<EmailInput
						id="emailAddress"
						name="emailAddress"
						value={this.state.emailAddress}
						onChange={this.onChange}
					/>
					<Label htmlFor="howCanWeHelpYou">How can we help you?</Label>
					<TextInput
						id="howCanWeHelpYou"
						name="howCanWeHelpYou"
						value={this.state.howCanWeHelpYou}
						onChange={this.onChange}
					/>
					<Label htmlFor="howDidYouHearAboutUs">
						How did you hear about us?
					</Label>
					<TextInput
						id="howDidYouHearAboutUs"
						name="howDidYouHearAboutUs"
						value={this.state.howDidYouHearAboutUs}
						onChange={this.onChange}
					/>
				</FormSection>
				<div className="grid">
					<div className="lg:justify-self-end">
						<FormSubmit onSubmit={this.onSubmit} label="Submit" />
					</div>
				</div>
				{/*	<PrimaryButton
						label="Test - Back"
						onClick={this.props.backLocation}
					/>
					<SecondaryButton
						label="Test - Continue"
						onClick={this.props.continueLocation}
					/> */}
			</div>
		);
	}

	onChange(e) {
		let { ...state } = this;
		state[e.target.name] = e.target.value;
		this.setState(state);
	}

	onSubmit(e) {
		// console.log('Create inquiry call stated...');
		e.preventDefault();
		e.stopPropagation();

		$.ajax({
			type: 'POST',
			url: this.props.endpoint,
			dataType: 'json',
			data: {
				name: this.state.name,
				email: this.state.emailAddress,
				how_can_we_help_you: this.state.howCanWeHelpYou,
				how_did_you_hear_about_us: this.state.howDidYouHearAboutUs
			},
			error: (response) => {
				// console.log('Create inquiry call failed.', data, data.responseJSON.errors);
				this.setState({ errors: response.responseJSON.errors });
				window.scrollTo({
					top: 0,
					left: 0,
					behavior: 'smooth'
				});
			}
		}).done((response, status) => {
			// console.log('Create inquiry call successful.', response, status);
		});
	}
}
